<template>
  <form
    class="w-100 d-flex justify-content-between align-items-center"
    style="background-color: var(--grey-light); border-radius: 8px"
  >
    <input
      type="search"
      name=""
      id=""
      placeholder="Buscar"
      class="w-100 border-0"
      style="
        background-color: transparent;
        height: 42px;
        padding-left: 14px;
        outline: none;
      "
      v-model="inputValue"
    />
    <img
      :src="require('@/assets/images/svg/ícone-buscar.svg')"
      alt=""
      style="margin: 13px"
    />
  </form>
</template>
<script>
export default {
  name: "InputSearch",
  data() {
    return {
      inputValue: "",
    };
  },
  watch: {
    inputValue(newValue) {
      this.$emit("onUpdate", newValue);
    },
  },
};
</script>
